import { Route } from '@angular/router';
import { authGuard } from '@seatix/check-in-data-access-scanner';
import { checkInGuestGuard } from '@seatix/shared/data-access/auth';

export const appRoutes: Route[] = [
  {
    path: 'login',
    canMatch: [checkInGuestGuard],
    loadComponent: async () =>
      (await import('@seatix/check-in-feat-auth')).FeatAuthLoginPage,
  },
  {
    path: '',
    children: [
      {
        path: 'unauthorized',
        loadComponent: async () =>
          (await import('@seatix/check-in-feat-errors')).FeatUnauthorizedPage,
      },
      {
        path: 'no-events',
        loadComponent: async () =>
          (await import('@seatix/check-in-feat-errors')).FeatNoEventsPage,
      },
      {
        path: 'scanner',
        loadComponent: async () =>
          (await import('@seatix/check-in-feat-shell')).ScannerShellPage,
        canMatch: [authGuard],
        children: [
          {
            path: '',
            loadComponent: async () =>
              (await import('@seatix/check-in-feat-scanner')).FeatScannerPage,
          },
        ],
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'scanner',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
